/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitDtoEdgeModel, VisitDtoEdgeModelType } from "./VisitDtoEdgeModel"
import { VisitDtoEdgeModelSelector } from "./VisitDtoEdgeModel.base"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  nodes: IObservableArray<VisitDtoModelType>;
}

/**
 * VisitPaginatedDtoBase
 * auto generated base class for the model VisitPaginatedDtoModel.
 */
export const VisitPaginatedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('VisitPaginatedDto')
  .props({
    __typename: types.optional(types.literal("VisitPaginatedDto"), "VisitPaginatedDto"),
    edges: types.union(types.undefined, types.null, types.array(types.late((): any => VisitDtoEdgeModel))),
    nodes: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => VisitDtoModel)))),
    totalCount: types.union(types.undefined, types.integer),
    hasNextPage: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class VisitPaginatedDtoModelSelector extends QueryBuilder {
  get totalCount() { return this.__attr(`totalCount`) }
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  edges(builder: string | VisitDtoEdgeModelSelector | ((selector: VisitDtoEdgeModelSelector) => VisitDtoEdgeModelSelector) | undefined) { return this.__child(`edges`, VisitDtoEdgeModelSelector, builder) }
  nodes(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`nodes`, VisitDtoModelSelector, builder) }
}
export function selectFromVisitPaginatedDto() {
  return new VisitPaginatedDtoModelSelector()
}

export const visitPaginatedDtoModelPrimitives = selectFromVisitPaginatedDto().totalCount.hasNextPage
